export const ENDING_TIMEOUT = 10000;
